import React, { useState, useEffect, useRef } from 'react';
import axios from '../axios';
import config from '../config';
import { useHistory } from 'react-router-dom';
import heartImage from '../logo192.png';
import stethoscopeImage from '../stethoscope.webp';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import './LoginForm.css';
import { trackFormSubmission } from '../utils/analytics';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import BankIdLogo from '../bankid/BankID_logo_black.svg';
import BankIdLogoWhite from '../bankid/BankID_logo_white.svg';
import { useLanguage } from '../i18n/LanguageContext';

function LoginForm({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // BankID related state - COMMENTED OUT FOR PRODUCTION
  // const [bankIdLoading, setBankIdLoading] = useState(false);
  // const [orderRef, setOrderRef] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  // const [bankIdMethod, setBankIdMethod] = useState('qrcode');
  // const [qrCodeData, setQrCodeData] = useState('');
  // const [qrExpiry, setQrExpiry] = useState(null);
  // const [isMobile, setIsMobile] = useState(false);
  // const [useQrFallback, setUseQrFallback] = useState(false);
  // const pollIntervalRef = useRef(null);
  // const qrRefreshTimerRef = useRef(null);
  const backend_url = config.backend_url;
  const history = useHistory();
  const { t } = useLanguage();
  // const [pollCount, setPollCount] = useState(0);
  // const isDevelopment = process.env.NODE_ENV === 'development';

  // COMMENTED OUT - BankID mobile detection logic
  /*
  // Detect if user is on a mobile device
  useEffect(() => {
    const checkMobile = () => {
      const forceMobile = new URLSearchParams(window.location.search).get('mobile') === 'true';
      
      if (forceMobile) {
        setIsMobile(true);
        setBankIdMethod('mobile');
        return;
      }
      
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Enhanced regex to detect both mobile phones and tablets
      const mobileTabletRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Tablet|Tab|Kindle|Silk|PlayBook|Mobile|Touch/i;
      
      // iPad detection - comprehensive check for all iPad variants including iPad Pro
      const isIPad = /iPad/i.test(userAgent) || 
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream) ||
                    /iPad|iPad Pro|iPad Air|iPad Mini/i.test(userAgent) ||
                    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
      
      // Windows tablet detection (Surface Pro, Surface Book, etc.)
      const isWindowsTablet = /Windows NT.*Touch/i.test(userAgent) ||
                             /Surface/i.test(userAgent) ||
                             (navigator.platform === 'Win32' && navigator.maxTouchPoints > 1) ||
                             /Tablet PC/i.test(userAgent);
      
      // Android tablet detection - improved to catch more variants
      const isAndroidTablet = /Android/i.test(userAgent) && !/Mobile/i.test(userAgent) ||
                             /Android.*Tablet/i.test(userAgent) ||
                             /SM-T|Galaxy Tab|Nexus [0-9]|Pixel C|Pixel Slate/i.test(userAgent);
      
      // Additional tablet detection for other brands
      const isOtherTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent.toLowerCase()) ||
                           /Kindle|Fire|GT-P|GT-N|SM-P|MediaPad|Transformer|TF[0-9]|Xoom|MZ[0-9]/i.test(userAgent);
      
      // Touch capability check for modern devices
      const hasTouchCapability = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      
      // Screen size based detection for edge cases (tablets typically have larger screens)
      const screenBasedTabletCheck = hasTouchCapability && 
                                    window.screen.width >= 768 && 
                                    window.screen.height >= 768;
      
      const isMobileOrTablet = mobileTabletRegex.test(userAgent) || 
                              isIPad || 
                              isWindowsTablet || 
                              isAndroidTablet || 
                              isOtherTablet ||
                              screenBasedTabletCheck;
      
      setIsMobile(isMobileOrTablet);
      
      // If mobile or tablet device, automatically set bankIdMethod to 'mobile'
      if (isMobileOrTablet) {
        setBankIdMethod('mobile');
      }
    };
    
    checkMobile();
  }, []);
  */

  // COMMENTED OUT - BankID cleanup useEffect
  /*
  useEffect(() => {
    // Clean up any intervals/timers when component unmounts
    return () => {
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
      if (qrRefreshTimerRef.current) clearTimeout(qrRefreshTimerRef.current);
    };
  }, []);
  */

  // COMMENTED OUT - BankID QR code refresh useEffect
  /*
  // Effect to refresh QR code when method is qrcode
  useEffect(() => {
    if (bankIdMethod === 'qrcode' || (isMobile && useQrFallback)) {
      // Initialize QR code on first selection or when mobile user chooses QR fallback
      generateQrCode();
    } else if (bankIdMethod === 'mobile' && isMobile && !useQrFallback) {
      // Always show the button first instead of auto-starting BankID
      // This ensures users can explicitly start BankID by clicking the button
      setBankIdLoading(false);
      
      // Clear any stored BankID session to ensure a fresh start
      localStorage.removeItem('bankid_orderRef');
      localStorage.removeItem('bankid_timestamp');
      localStorage.removeItem('bankid_overlay');
      localStorage.removeItem('bankid_launch_time');
      localStorage.removeItem('bankid_url');
    } else {
      // Clean up QR code related timers when not using QR code method
      if (qrRefreshTimerRef.current) {
        clearTimeout(qrRefreshTimerRef.current);
        qrRefreshTimerRef.current = null;
      }
      setQrCodeData('');
    }
  }, [bankIdMethod, useQrFallback, isMobile]);
  */

  // COMMENTED OUT - BankID session checking useEffect
  /*
  // Effect to check for returning from BankID app
  useEffect(() => {
    const checkPendingBankIdSession = () => {
      // Don't check if we're already polling to avoid duplicate sessions
      if (pollIntervalRef.current) {
        return;
      }

      // On mobile devices, don't auto-resume sessions when the login form opens
      // This prevents the "Startar BankID..." message from showing automatically
      if (isMobile) {
        return;
      }

      const storedOrderRef = localStorage.getItem('bankid_orderRef');
      const timestamp = localStorage.getItem('bankid_timestamp');
      
      // Only check if we have a stored orderRef and it's less than 10 minutes old
      if (storedOrderRef && timestamp) {
        const sessionAge = Date.now() - parseInt(timestamp);
        const sessionValid = sessionAge < 10 * 60 * 1000; // 10 minutes
        
        if (sessionValid) {
          // Resume BankID session
          setOrderRef(storedOrderRef);
          setBankIdLoading(true);
          startPolling(storedOrderRef);
        } else {
          // Clear expired session
          localStorage.removeItem('bankid_orderRef');
          localStorage.removeItem('bankid_timestamp');
          localStorage.removeItem('bankid_launch_time');
          localStorage.removeItem('bankid_url');
        }
      }
    };
    
    // Check for pending session when component mounts, but with a slight delay
    // to avoid race conditions with other component initialization
    const initTimer = setTimeout(() => {
      checkPendingBankIdSession();
    }, 500);
    
    // Also check when the window regains focus (user returns from BankID app)
    const handleFocus = () => {
      // Update the last activity time
      localStorage.setItem('bankid_last_focus', Date.now().toString());
      
      // Add a small delay to ensure app state is settled after focus change
      setTimeout(() => {
        checkPendingBankIdSession();
      }, 300);
    };
    
    // Check when visibility changes (more reliable than focus on some browsers)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Update the last activity time
        localStorage.setItem('bankid_last_focus', Date.now().toString());
        
        // Add a small delay to ensure app state is settled after visibility change
        setTimeout(() => {
          checkPendingBankIdSession();
        }, 300);
      }
    };
    
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(initTimer);
    };
  }, [isMobile]);
  */

  // COMMENTED OUT - BankID cleanup sessions useEffect
  /*
  // Add effect to clear any leftover BankID sessions on component mount
  useEffect(() => {
    // Check for outdated BankID sessions and clean them up on component mount
    const cleanupExistingSessions = () => {
      const storedOrderRef = localStorage.getItem('bankid_orderRef');
      const timestamp = localStorage.getItem('bankid_timestamp');
      
      if (storedOrderRef) {
        // Clear all BankID related data to ensure a fresh start
        localStorage.removeItem('bankid_orderRef');
        localStorage.removeItem('bankid_timestamp');
        localStorage.removeItem('bankid_overlay');
        localStorage.removeItem('bankid_launch_time');
        localStorage.removeItem('bankid_url');
        localStorage.removeItem('bankid_last_focus');
      }
    };
    
    cleanupExistingSessions();
  }, []);
  */

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSubmit(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // COMMENTED OUT - Mobile BankID auto-launch logic
    // if (isMobile) {
    //   launchMobileBankId();
    //   return;
    // }
    
    setLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post(
        `${backend_url}/api/login`,
        {
          username,
          password,
        },
        { withCredentials: true }
      );

      if (response.status === 200) {
        const { message, user_type, user_id, token, firstname, lastname } = response.data;

        // Store the token in localStorage as a fallback authentication method
        if (token) {
          localStorage.setItem('authToken', token);
          // Set the token in axios default headers for all future requests
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }

        // Store user's name if available
        if (firstname) localStorage.setItem('firstname', firstname);
        if (lastname) localStorage.setItem('lastname', lastname);

        onLogin(user_type, user_id);
        
        // Check if login comes from header - if so, always redirect to home
        const urlParams = new URLSearchParams(window.location.search);
        const fromHeader = urlParams.get('from_header') === 'true';
        
        if (fromHeader) {
          // Always redirect to home when coming from header login
          history.push('/');
        } else {
          // Default behavior: redirect to object-form for sellers, home for brokers
          if (user_type === 'seller') {
            history.push('/object-form?workflow=direct');
          } else {
            history.push('/');
          }
        }
      } else {
        setErrorMessage(t('auth.loginFailed'));
      }
    } catch (error) {
      console.error(error.response);
      setErrorMessage(error.response?.data?.message || t('auth.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  // COMMENTED OUT - All BankID functions for production
  /*
  // Function to launch BankID on mobile devices
  const launchMobileBankId = async () => {
    // Don't start a new session if we're already loading
    if (bankIdLoading) {
      return;
    }
    
    setBankIdLoading(true);
    setErrorMessage('');

    try {
      // First, clean up any existing sessions to avoid conflicts
      localStorage.removeItem('bankid_orderRef');
      localStorage.removeItem('bankid_timestamp');
      localStorage.removeItem('bankid_launch_time');
      localStorage.removeItem('bankid_url');
      clearPollingAndTimers();
      
      // Request auth session from backend
      const authResponse = await axios.post(`${backend_url}/bankid/auth`, {
        qr_code: true // Request autoStartToken for mobile launch
      });

      const { orderRef, autoStartToken } = authResponse.data;
      
      if (!orderRef) {
        console.error("Missing orderRef in response");
        setErrorMessage('Kunde inte starta BankID: Saknar orderRef.');
        setBankIdLoading(false);
        return;
      }
      
      // Store the order reference for resuming session later
      localStorage.setItem('bankid_orderRef', orderRef);
      localStorage.setItem('bankid_timestamp', Date.now().toString());
      
      // Start polling BEFORE launching the app
      startPolling(orderRef);
      
      // Wait a moment to ensure polling is properly established
      await new Promise(resolve => setTimeout(resolve, 800));
      
      // Determine best URL format based on available data
      let bankIdUrl;
      let urlType;
      
      if (autoStartToken) {
        // Preferred format with autoStartToken (most reliable)
        bankIdUrl = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
        urlType = "autoStartToken";
      } else {
        // Fallback to simpler format with just orderRef
        bankIdUrl = `bankid://${orderRef}`;
        urlType = "orderRef";
      }
      
      localStorage.setItem('bankid_url', bankIdUrl);
      
      // Create an invisible iframe for initial launch attempt
      // This can help with launch on some devices
      try {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = bankIdUrl;
        document.body.appendChild(iframe);
        
        // Remove iframe after a moment
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 500);
      } catch (iframeError) {
        // Iframe launch failed, using direct method
      }
      
      // Direct launch as backup - most universally supported method
      setTimeout(() => {
        window.location.href = bankIdUrl;
      }, 100);
      
    } catch (error) {
      console.error("Error launching mobile BankID:", error);
      console.error("Error response:", error.response?.data || error.message);
      setErrorMessage('Kunde inte starta BankID-appen. Försök igen senare.');
      setBankIdLoading(false);
    }
  };

  // Simple function specifically for manual BankID launch
  const manualLaunchBankId = () => {
    const orderRef = localStorage.getItem('bankid_orderRef');
    const storedUrl = localStorage.getItem('bankid_url');
    
    if (!orderRef) {
      launchMobileBankId();
      return;
    }
    
    try {
      if (storedUrl) {
        // Use the stored URL which may contain autoStartToken format
        window.location.href = storedUrl;
      } else {
        // Fallback to simple format
        window.location.href = `bankid://${orderRef}`;
      }
    } catch (error) {
      console.error("Error in manual launch:", error);
      setErrorMessage('Kunde inte starta BankID-appen. Försök igen.');
    }
  };

  const generateQrCode = async () => {
    try {
      setBankIdLoading(true);
      setErrorMessage('');
      
      // Request a QR code auth session from backend
      const authResponse = await axios.post(`${backend_url}/bankid/auth`, {
        qr_code: true
      });

      const { orderRef, qrCode, autoStartToken } = authResponse.data;
      
      if (!orderRef) {
        console.error("Missing orderRef in response");
        setErrorMessage('Kunde inte generera QR-kod: Saknar orderRef.');
        setBankIdLoading(false);
        return;
      }
      
      // Set order reference for polling
      setOrderRef(orderRef);
      
      // For BankID QR codes, try different formats depending on what the backend provided
      let qrData;
      
      if (autoStartToken) {
        // Format for BankID app with autoStartToken
        qrData = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
      } else if (qrCode) {
        // Use provided QR code data if available
        qrData = qrCode;
      } else {
        // Use standard BankID format as fallback
        // In production, this should follow BankID's specification
        qrData = `bankid://${orderRef}`;
      }
      
      setQrCodeData(qrData);
      
      // Set expiry time for QR - usually 30-60 seconds before refresh
      const expiryTime = new Date();
      expiryTime.setSeconds(expiryTime.getSeconds() + 30); // 30 seconds expiry
      setQrExpiry(expiryTime);
      
      // Start polling for auth status
      startPolling(orderRef);
      
      // Schedule next QR refresh
      scheduleQrRefresh();
      
    } catch (error) {
      console.error("Error generating QR code:", error);
      console.error("Error details:", error.response?.data);
      setErrorMessage('Kunde inte generera QR-kod. Försök igen senare.');
      setBankIdLoading(false);
    }
  };

  const scheduleQrRefresh = () => {
    // Clear any existing timer
    if (qrRefreshTimerRef.current) {
      clearTimeout(qrRefreshTimerRef.current);
    }
    
    // Schedule refresh for 30 seconds later
    qrRefreshTimerRef.current = setTimeout(() => {
      if (bankIdMethod === 'qrcode' || (isMobile && useQrFallback)) {
        generateQrCode();
      }
    }, 30000); // 30 seconds
  };

  const startPolling = (orderRef) => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
    }
    
    // Set the order reference state
    setOrderRef(orderRef);
    
    // Store in localStorage for session resumption
    localStorage.setItem('bankid_orderRef', orderRef);
    localStorage.setItem('bankid_timestamp', Date.now().toString());
    
    setPollCount(0);
    pollIntervalRef.current = setInterval(() => {
      setPollCount(prevCount => prevCount + 1);
      pollBankIdStatus(orderRef);
    }, 2000);
    
    // Set a maximum polling time (5 minutes)
    setTimeout(() => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        setErrorMessage('BankID-processen tog för lång tid. Vänligen försök igen.');
        setBankIdLoading(false);
        localStorage.removeItem('bankid_orderRef');
        localStorage.removeItem('bankid_timestamp');
        localStorage.removeItem('bankid_launch_time');
        localStorage.removeItem('bankid_url');
      }
    }, 300000); // 5 minutes
  };

  const pollBankIdStatus = async (orderRef) => {
    try {
      // Check if we still have a valid session
      const storedOrderRef = localStorage.getItem('bankid_orderRef');
      if (storedOrderRef !== orderRef) {
        return; // Don't continue polling if the orderRef has changed
      }
      
      const statusResponse = await axios.post(
        `${backend_url}/bankid/collect`,
        { order_ref: orderRef },
        { withCredentials: true }
      );

      const { status, hintCode, completionData, token } = statusResponse.data;

      if (status === 'complete') {
        // Stop polling immediately
        clearPollingAndTimers();
        
        // Clean up stored BankID session data
        localStorage.removeItem('bankid_orderRef');
        localStorage.removeItem('bankid_timestamp');
        localStorage.removeItem('bankid_launch_time');
        localStorage.removeItem('bankid_url');
        
        // Update UI state
        setBankIdLoading(false);
        
        // Store token
        if (token) {
          localStorage.setItem('authToken', token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        
        // Store user info
        if (completionData && completionData.user) {
          const userData = completionData.user;
          
          if (userData.personnummer) {
            localStorage.setItem('personnummer', userData.personnummer);
          }
          if (userData.firstname) localStorage.setItem('firstname', userData.firstname);
          if (userData.lastname) localStorage.setItem('lastname', userData.lastname);
        }
        
        // Check for cookie data
        const personnummerCookie = document.cookie
          .split('; ')
          .find(row => row.startsWith('personnummer='));
          
        if (personnummerCookie) {
          const personnummer = personnummerCookie.split('=')[1];
          localStorage.setItem('personnummer', personnummer);
        }
        
        // Validate we have required data
        if (!completionData || !completionData.user || !completionData.user.type || !completionData.user.id) {
          console.error("Missing required user data:", completionData);
          setErrorMessage('Inloggningen lyckades men användardatan är ofullständig. Vänligen försök igen.');
          return;
        }
        
        // Update authentication state
        localStorage.setItem('loggedIn', 'true');
        localStorage.setItem('userType', completionData.user.type);
        localStorage.setItem('userId', completionData.user.id);
        
        // Track successful BankID login
        trackFormSubmission('login_success', {
          login_method: 'bankid',
          user_type: completionData.user.type,
          device_type: isMobile ? 'mobile' : 'desktop'
        });
        
        // Do the actual redirect with a full page reload
        const handleSuccess = () => {
          try {
            // Call onLogin to update app state
            onLogin(completionData.user.type, completionData.user.id);
            
            // Check if login comes from header - if so, always redirect to home
            const urlParams = new URLSearchParams(window.location.search);
            const fromHeader = urlParams.get('from_header') === 'true';
            
            if (fromHeader) {
              // Always redirect to home when coming from header login
              window.location.href = '/';
            } else {
              // Default behavior: redirect to object-form with direct workflow for sellers, home for brokers
              if (completionData.user.type === 'seller') {
                window.location.href = '/object-form?workflow=direct';
              } else {
                window.location.href = '/';
              }
            }
          } catch (error) {
            console.error("Error during login completion:", error);
            setErrorMessage('Ett fel uppstod vid inloggningen. Vänligen försök igen.');
          }
        };
        
        // Call with a slight delay to let the browser process local storage updates
        setTimeout(handleSuccess, 500);
        
      } else if (status === 'failed') {
        console.error("BankID authentication failed:", hintCode);
        
        // Clean up
        clearPollingAndTimers();
        localStorage.removeItem('bankid_orderRef');
        localStorage.removeItem('bankid_timestamp');
        localStorage.removeItem('bankid_launch_time');
        localStorage.removeItem('bankid_url');
        setBankIdLoading(false);
        
        // Display error based on hint code
        const errorMessages = {
          'cancelled': 'BankID-inloggningen avbröts.',
          'userCancel': 'Du avbröt BankID-inloggningen.',
          'expiredTransaction': 'BankID-inloggningen tog för lång tid. Försök igen.',
          'certificateErr': 'Problem med BankID-certifikatet. Prova att uppdatera din BankID-app.',
          'userSign': 'Fel vid BankID-signering.',
          'startFailed': 'BankID-inloggningen kunde inte startas.',
          'outstandingTransaction': 'Du har redan en pågående BankID-session. Avsluta den och försök igen.'
        };
        
        setErrorMessage(errorMessages[hintCode] || `BankID-inloggningen misslyckades: ${hintCode}`);
      } else if (status === 'pending') {
        // Only log hintCode for pending status
        if (hintCode) {
          // If we get outstandingTransaction, we may need to restart
          if (hintCode === 'outstandingTransaction') {
            // No action needed - just let the user know in the UI what's happening
          }
        }
      }
    } catch (error) {
      console.error("Error polling BankID status:", error);
      
      // Handle critical errors only - temp network errors should continue polling
      if (error.response?.status === 400 || error.response?.status === 404) {
        console.error("Critical error - stopping polling");
        clearPollingAndTimers();
        localStorage.removeItem('bankid_orderRef');
        localStorage.removeItem('bankid_timestamp');
        localStorage.removeItem('bankid_launch_time');
        localStorage.removeItem('bankid_url');
        setBankIdLoading(false);
        setErrorMessage('Ett fel uppstod vid kontroll av BankID-status. Försök igen senare.');
      }
    }
  };

  const clearPollingAndTimers = () => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    if (qrRefreshTimerRef.current) {
      clearTimeout(qrRefreshTimerRef.current);
      qrRefreshTimerRef.current = null;
    }
  };

  // Calculate time remaining for QR code
  const getQrTimeRemaining = () => {
    if (!qrExpiry) return null;
    
    const now = new Date();
    const diffMs = qrExpiry - now;
    
    if (diffMs <= 0) return 0;
    
    return Math.ceil(diffMs / 1000); // Return seconds remaining
  };

  const timeRemaining = getQrTimeRemaining();

  const handleRefresh = () => {
    // Clear everything first
    clearPollingAndTimers();
    localStorage.removeItem('bankid_orderRef');
    localStorage.removeItem('bankid_timestamp');
    localStorage.removeItem('bankid_launch_time');
    localStorage.removeItem('bankid_url');
    
    // Reset UI state to show the "Starta BankID" button
    setBankIdLoading(false);
    setErrorMessage('');
  };
  */

  const handleClose = () => {
    history.goBack();
  };

  return (
    <div className="login-overlay">
      <div className="login-overlay-backdrop"></div>
      <div className="login-overlay-container">
        <button className="close-button" onClick={handleClose}>×</button>
        <div className="login-form-container">
          <div className="login-header">
            <img src={heartImage} alt="Heart" style={{ display: 'none', marginRight: '20px' }} />
            <h1>{t('auth.loginTitle')}</h1>
            <img src={stethoscopeImage} alt="Stethoscope" style={{ display: 'none', marginLeft: '20px' }} />
          </div>
          
          {/* COMMENTED OUT - BankID logo container
          <div className="bankid-logo-container">
            <img src={BankIdLogo} alt="BankID" className="modal-bankid-logo" />
          </div>
          */}
          
          <div className="form-content">
            {errorMessage && (
              <div className="error-message">
                {errorMessage}
              </div>
            )}
            
            {/* Username/password login form - enabled for production */}
            {(
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="username">{t('auth.username')}:</label>
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={handleKeyDown}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="password">{t('auth.password')}:</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    required
                  />
                </div>
                
                <div className="button-container">
                  <button type="submit" disabled={loading} className="primary-button">
                    {loading ? t('auth.loggingIn') : t('auth.loginTitle')}
                  </button>
                  <Link to="/" style={{ textDecoration: 'none' }}>
                    <button className="primary-button">{t('common.home')}</button>
                  </Link>
                </div>
              </form>
            )}
            
            
            {/* COMMENTED OUT FOR PRODUCTION: BankID login section removed.
                All BankID-related UI components, QR code generation, mobile BankID launch,
                and polling functionality has been disabled for production use.
                Username/password login is now the primary authentication method. */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
